import { useAppSelector } from './store';

export default function useApiSelector() {
    const { description, variant, showToast } = useAppSelector(state => state.reducer.api);
    return { description, variant, showToast };
}
